// extracted by mini-css-extract-plugin
module.exports = {"box":"product-colorbox-module--box--2IZgD","image":"product-colorbox-module--image--3TauR","label":"product-colorbox-module--label--3gSBk"};